import { ArticleOutlined } from '@mui/icons-material';
import { ReactComponent as CollectionConfluenceIcon } from 'src/assets/documentIcons/collection-confluence.svg';
import { ReactComponent as CollectionOneDriveIcon } from 'src/assets/documentIcons/collection-onedrive-icon.svg';
import { ReactComponent as CollectionSharePointIcon } from 'src/assets/documentIcons/collection-sharepoint-icon.svg';
import { ReactComponent as ConfluenceFolderIcon } from 'src/assets/documentIcons/confluence-folder-icon.svg';
import { ReactComponent as NestedPageIconOld } from 'src/assets/documentIcons/confluence-nested-page-icon.svg';
import { ReactComponent as CPageIcon } from 'src/assets/documentIcons/confluence-page-icon.svg';
import { ReactComponent as CExcelIcon } from 'src/assets/documentIcons/excel-confluence-icon.svg';
import { ReactComponent as ExcelIcon } from 'src/assets/documentIcons/excel-icon.svg';
import { ReactComponent as ODExcelIcon } from 'src/assets/documentIcons/excel-onedrive-icon.svg';
import { ReactComponent as SPExcelIcon } from 'src/assets/documentIcons/excel-sharepoint-icon.svg';
import { ReactComponent as MP3IconOld } from 'src/assets/documentIcons/mp3-icon.svg';
import { ReactComponent as MP4IconOld } from 'src/assets/documentIcons/mp4-icon.svg';
import { ReactComponent as CMsWordIcon } from 'src/assets/documentIcons/ms-word-confluence-icon.svg';
import { ReactComponent as MsWordIcon } from 'src/assets/documentIcons/ms-word-icon.svg';
import { ReactComponent as ODMsWordIcon } from 'src/assets/documentIcons/ms-word-onedrive-icon.svg';
import { ReactComponent as SPMsWordIcon } from 'src/assets/documentIcons/ms-word-sharepoint-icon.svg';
import { ReactComponent as OneDriveFolderIcon } from 'src/assets/documentIcons/onedrive-folder-icon.svg';
import { ReactComponent as CPdfIcon } from 'src/assets/documentIcons/pdf-confluence-icon.svg';
import { ReactComponent as PdfIconOld } from 'src/assets/documentIcons/pdf-icon.svg';
import { ReactComponent as ODPdfIcon } from 'src/assets/documentIcons/pdf-onedrive-icon.svg';
import { ReactComponent as SPPdfIcon } from 'src/assets/documentIcons/pdf-sharepoint-icon.svg';
import { ReactComponent as CPptIcon } from 'src/assets/documentIcons/ppt-confluence-icon.svg';
import { ReactComponent as PptIconOld } from 'src/assets/documentIcons/ppt-icon.svg';
import { ReactComponent as ODPptIcon } from 'src/assets/documentIcons/ppt-onedrive-icon.svg';
import { ReactComponent as SPPptIcon } from 'src/assets/documentIcons/ppt-sharepoint-icon.svg';
import { ReactComponent as SharepointFolderIcon } from 'src/assets/documentIcons/sharepoint-folder-icon.svg';
import { ReactComponent as BLOBIcon } from 'src/assets/tailwind/document/blob.svg';
import { ReactComponent as DOCIcon } from 'src/assets/tailwind/document/doc.svg';
import { ReactComponent as DOCXIcon } from 'src/assets/tailwind/document/docx.svg';
import { ReactComponent as FolderIcon } from 'src/assets/tailwind/document/folder.svg';
import { ReactComponent as HTMLIcon } from 'src/assets/tailwind/document/html.svg';
import { ReactComponent as M4AIcon } from 'src/assets/tailwind/document/m4a.svg';
import { ReactComponent as MP3Icon } from 'src/assets/tailwind/document/mp3.svg';
import { ReactComponent as MP4Icon } from 'src/assets/tailwind/document/mp4.svg';
import { ReactComponent as MPEGIcon } from 'src/assets/tailwind/document/mpeg.svg';
import { ReactComponent as MPGAIcon } from 'src/assets/tailwind/document/mpga.svg';
import { ReactComponent as NestedPageIcon } from 'src/assets/tailwind/document/nested-page.svg';
import { ReactComponent as ODPIcon } from 'src/assets/tailwind/document/odp.svg';
import { ReactComponent as ODSIcon } from 'src/assets/tailwind/document/ods.svg';
import { ReactComponent as ODTIcon } from 'src/assets/tailwind/document/odt.svg';
import { ReactComponent as PAGEIcon } from 'src/assets/tailwind/document/page.svg';
import { ReactComponent as PdfIcon } from 'src/assets/tailwind/document/pdf.svg';
import { ReactComponent as PptIcon } from 'src/assets/tailwind/document/ppt.svg';
import { ReactComponent as PPTXIcon } from 'src/assets/tailwind/document/pptx.svg';
import { ReactComponent as TXTIcon } from 'src/assets/tailwind/document/txt.svg';
import { ReactComponent as WAVIcon } from 'src/assets/tailwind/document/wav.svg';
import { ReactComponent as WEBIcon } from 'src/assets/tailwind/document/web.svg';
import { ReactComponent as WEBMIcon } from 'src/assets/tailwind/document/webm.svg';
import { ReactComponent as XLSIcon } from 'src/assets/tailwind/document/xls.svg';
import { ReactComponent as XLSXIcon } from 'src/assets/tailwind/document/xlsx.svg';
import { ReactComponent as CSVIcon } from 'src/assets/tailwind/document/csv.svg';
import { ReactComponent as RTFIcon } from 'src/assets/tailwind/document/rtf.svg';
import JsonIcon from 'src/assets/tailwind/json_file_type.svg';
import {
  FILE_EXTENSIONS,
  RESOURCE_PROVIDERS,
  RESOURCE_TYPE,
  SUPPORTED_UPLOAD_FILES_FORMAT
} from 'src/types/enum';

export const FILE_NAME_LENGTH_LIMIT = 200;
export const SUPPORTED_AV_FORMATS = [
  'mp3',
  'mp4',
  'mpeg',
  'mpga',
  'm4a',
  'wav',
  'webm',
  'weba',
  'mov',
  'm4v',
  '3gp',
  'aac',
  'caf',
  'amr',
  'audio',
  'video'
];

export const isSupportedFormat = (fileType: any): boolean => {
  return Object.values(SUPPORTED_UPLOAD_FILES_FORMAT).includes(fileType);
};

export const isSupportedExtension = (fileExtension: string): boolean => {
  return [...(Object.values(FILE_EXTENSIONS) as string[])].includes(
    fileExtension
  );
};

const ProvidersFilesIconsMap = {
  [RESOURCE_PROVIDERS.SHAREPOINT]: {
    [FILE_EXTENSIONS.PDF]: SPPdfIcon,
    [FILE_EXTENSIONS.PPT]: SPPptIcon,
    [FILE_EXTENSIONS.XLSX]: SPExcelIcon,
    [FILE_EXTENSIONS.DOCX]: SPMsWordIcon,
    // Audio
    [FILE_EXTENSIONS.MP3]: MP3IconOld,
    [FILE_EXTENSIONS.MPGA]: MP3IconOld,
    [FILE_EXTENSIONS.M4A]: MP3IconOld,
    [FILE_EXTENSIONS.WAV]: MP3IconOld,
    [FILE_EXTENSIONS.AAC]: MP3IconOld,
    [FILE_EXTENSIONS.CAF]: MP3IconOld,
    [FILE_EXTENSIONS.AMR]: MP3IconOld,

    // Video
    [FILE_EXTENSIONS.MP4]: MP4IconOld,
    [FILE_EXTENSIONS.MPEG]: MP4IconOld,
    [FILE_EXTENSIONS.WEBM]: MP4IconOld
  },
  [RESOURCE_PROVIDERS.ONEDRIVE]: {
    [FILE_EXTENSIONS.PDF]: ODPdfIcon,
    [FILE_EXTENSIONS.PPT]: ODPptIcon,
    [FILE_EXTENSIONS.XLSX]: ODExcelIcon,
    [FILE_EXTENSIONS.DOCX]: ODMsWordIcon
  },
  [RESOURCE_PROVIDERS.CONFLUENCE]: {
    [FILE_EXTENSIONS.PDF]: CPdfIcon,
    [FILE_EXTENSIONS.PPT]: CPptIcon,
    [FILE_EXTENSIONS.XLSX]: CExcelIcon,
    [FILE_EXTENSIONS.DOCX]: CMsWordIcon,
    [FILE_EXTENSIONS.PAGE]: CPageIcon,
    [FILE_EXTENSIONS.BLOG_POST]: CMsWordIcon,
    [FILE_EXTENSIONS.NESTED_PAGE]: NestedPageIconOld
  },
  [RESOURCE_PROVIDERS.GOOGLEDRIVE]: {
    [FILE_EXTENSIONS.JSON]: JsonIcon
  }
};

const getProviderFileIcon = (provider = '', file = '') => {
  return ProvidersFilesIconsMap[provider]?.[file] || null;
};

const FILE_FORMAT_CATEGORIES = {
  [FILE_EXTENSIONS.PDF]: [
    SUPPORTED_UPLOAD_FILES_FORMAT.PDF,
    FILE_EXTENSIONS.PDF
  ],

  [FILE_EXTENSIONS.MP3]: [
    SUPPORTED_UPLOAD_FILES_FORMAT.MP3,
    SUPPORTED_UPLOAD_FILES_FORMAT.M4A,
    SUPPORTED_UPLOAD_FILES_FORMAT.MPGA,
    SUPPORTED_UPLOAD_FILES_FORMAT.MPEG,
    SUPPORTED_UPLOAD_FILES_FORMAT.MP4,
    SUPPORTED_UPLOAD_FILES_FORMAT.WAV,
    SUPPORTED_UPLOAD_FILES_FORMAT.WEBM,

    FILE_EXTENSIONS.MP3,
    FILE_EXTENSIONS.M4A,
    FILE_EXTENSIONS.MPGA,
    FILE_EXTENSIONS.MPEG,
    FILE_EXTENSIONS.MP4,
    FILE_EXTENSIONS.WAV,
    FILE_EXTENSIONS.WEBM
  ],

  [FILE_EXTENSIONS.PPT]: [
    SUPPORTED_UPLOAD_FILES_FORMAT.PPT,
    SUPPORTED_UPLOAD_FILES_FORMAT.PPTX,
    SUPPORTED_UPLOAD_FILES_FORMAT.ODP,
    FILE_EXTENSIONS.PPT,
    FILE_EXTENSIONS.PPTX,
    FILE_EXTENSIONS.ODP
  ],

  [FILE_EXTENSIONS.DOCX]: [
    SUPPORTED_UPLOAD_FILES_FORMAT.DOC,
    SUPPORTED_UPLOAD_FILES_FORMAT.DOCX,
    SUPPORTED_UPLOAD_FILES_FORMAT.ODT,
    FILE_EXTENSIONS.DOC,
    FILE_EXTENSIONS.DOCX,
    FILE_EXTENSIONS.ODT,
    FILE_EXTENSIONS.BLOG_POST
  ],

  [FILE_EXTENSIONS.XLSX]: [
    SUPPORTED_UPLOAD_FILES_FORMAT.XLS,
    SUPPORTED_UPLOAD_FILES_FORMAT.XLSX,
    SUPPORTED_UPLOAD_FILES_FORMAT.ODS,
    FILE_EXTENSIONS.XLS,
    FILE_EXTENSIONS.XLSX,
    FILE_EXTENSIONS.ODS,
    FILE_EXTENSIONS.CSV
  ],
  [FILE_EXTENSIONS.JSON]: [FILE_EXTENSIONS.JSON]
};

const CATEGORY_ICONS = {
  [FILE_EXTENSIONS.PDF]: PdfIconOld,
  [FILE_EXTENSIONS.MP3]: MP3IconOld,
  [FILE_EXTENSIONS.MP4]: MP4IconOld,
  [FILE_EXTENSIONS.PPT]: PptIconOld,
  [FILE_EXTENSIONS.DOCX]: MsWordIcon,
  [FILE_EXTENSIONS.XLSX]: ExcelIcon,
  [FILE_EXTENSIONS.CSV]: ExcelIcon
};

// Dynamically generate DEFAULT_ICONS from FILE_FORMAT_CATEGORIES
const DEFAULT_ICONS = Object.entries(FILE_FORMAT_CATEGORIES).reduce(
  (acc, [categoryKey, extensions]) => {
    const iconComponent = CATEGORY_ICONS[categoryKey];

    extensions.forEach((extension) => {
      acc[extension] = iconComponent;
    });

    return acc;
  },
  {}
);

type SupportedFileType = FILE_EXTENSIONS | SUPPORTED_UPLOAD_FILES_FORMAT;

export const normalizeFileType = (fileType: string): SupportedFileType | '' => {
  if (!fileType) {
    return '';
  }

  let ext = fileType.toLowerCase();
  if (ext.includes('/') && !ext.startsWith('application')) {
    ext = ext.split('/')[1];
  }
  // Strip "x-" prefix if present (e.g., x-m4a → m4a)
  if (ext.startsWith('x-')) {
    ext = ext.slice(2);
  } else if (ext === 'audio') {
    ext = FILE_EXTENSIONS.MP3;
  }

  return ext as SupportedFileType;
};
export const getFileIcon = (
  fileType: any = '',
  externalType: string = '',
  providerType = ''
) => {
  const normalizedType = normalizeFileType(fileType);

  const extension =
    normalizedType &&
    Object.entries(FILE_FORMAT_CATEGORIES).find(([_, formats]) =>
      formats.includes(normalizedType)
    )?.[0];

  return providerType
    ? getProviderFileIcon(
        providerType,
        normalizedType === FILE_EXTENSIONS.HTML && externalType
          ? externalType
          : extension
      )
    : extension
    ? DEFAULT_ICONS[normalizedType]
    : ArticleOutlined;
};

export const ResourceProviderFolder = {
  [RESOURCE_PROVIDERS.SHAREPOINT]: SharepointFolderIcon,
  [RESOURCE_PROVIDERS.ONEDRIVE]: OneDriveFolderIcon,
  [RESOURCE_PROVIDERS.CONFLUENCE]: ConfluenceFolderIcon
};

export const ResourceProviderCollection = {
  [RESOURCE_PROVIDERS.SHAREPOINT]: CollectionSharePointIcon,
  [RESOURCE_PROVIDERS.ONEDRIVE]: CollectionOneDriveIcon,
  [RESOURCE_PROVIDERS.CONFLUENCE]: CollectionConfluenceIcon
};

export const FileExtensionIconMapper = {
  [RESOURCE_TYPE.COLLECTION]: {
    folder: FolderIcon
  },

  [RESOURCE_TYPE.FOLDER]: {
    folder: FolderIcon
  },

  [RESOURCE_TYPE.FILE]: {
    [FILE_EXTENSIONS.PDF]: PdfIcon,
    [FILE_EXTENSIONS.DOC]: DOCIcon,
    [FILE_EXTENSIONS.DOCX]: DOCXIcon,
    [FILE_EXTENSIONS.ODT]: ODTIcon,
    [FILE_EXTENSIONS.TXT]: TXTIcon,
    [FILE_EXTENSIONS.RTF]: RTFIcon,

    [FILE_EXTENSIONS.XLS]: XLSIcon,
    [FILE_EXTENSIONS.XLSX]: XLSXIcon,
    [FILE_EXTENSIONS.CSV]: CSVIcon,
    [FILE_EXTENSIONS.ODS]: ODSIcon,

    [FILE_EXTENSIONS.PPT]: PptIcon,
    [FILE_EXTENSIONS.PPTX]: PPTXIcon,
    [FILE_EXTENSIONS.ODP]: ODPIcon,

    [FILE_EXTENSIONS.HTML]: HTMLIcon,
    [FILE_EXTENSIONS.PAGE]: PAGEIcon,
    [FILE_EXTENSIONS.NESTED_PAGE]: NestedPageIcon,
    [FILE_EXTENSIONS.WEB]: WEBIcon,
    [FILE_EXTENSIONS.BLOG_POST]: BLOBIcon,

    [FILE_EXTENSIONS.MP3]: MP3Icon,
    [FILE_EXTENSIONS.MPGA]: MPGAIcon,
    [FILE_EXTENSIONS.WAV]: WAVIcon,
    [FILE_EXTENSIONS.M4A]: M4AIcon,

    [FILE_EXTENSIONS.AAC]: M4AIcon,
    [FILE_EXTENSIONS.CAF]: M4AIcon,
    [FILE_EXTENSIONS.AMR]: M4AIcon,

    [FILE_EXTENSIONS.MP4]: MP4Icon,
    [FILE_EXTENSIONS.MPEG]: MPEGIcon,
    [FILE_EXTENSIONS.WEBM]: WEBMIcon,
    [FILE_EXTENSIONS.MOV]: MP4Icon,
    [FILE_EXTENSIONS.M4V]: MP4Icon,
    [FILE_EXTENSIONS.THREE_GP]: MP4Icon
  }
} as const;
